<template>
  <div class="notice-detail">
    <div class="notice-detail-text-box" @click="clickSentence">
      <div v-if="data.type === 'info'" class="notice-detail-label info">お知らせ</div>
      <div v-else-if="data.type === 'release'" class="notice-detail-label release">リリース</div>
      <div v-else-if="data.type === 'campaign'" class="notice-detail-label campaign">キャンペーン</div>
      <h4 class="notice-detail-date">{{ data.date }}</h4>
      <h4 class="notice-detail-name">{{ data.name }}</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoticeDetail',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    clickSentence() {
      this.$emit('clickSentence', this.data);
    }
  }
};
</script>

<style lang="scss" scoped>
.notice-detail {
  @media screen and (max-width: 960px) {
    max-width: 520px;
    margin: 0 auto;
  }

  &-text-box {
    cursor: pointer;
    margin: 1.5em auto;
    width: 100%;
    max-width: 600px;
    height: 60px;
    color: #666666;
    background-color: white;
    border-radius: 10px;
    outline: 3px solid#ffd295;
    display: flex;
    gap: 8px;
    padding: 12px;
  }

  &-label {
    width: 66px;
    min-width: 65px;
    height: 22px;
    color: white;
    border-radius: 5px;
    margin: auto;
    text-align: center;
    position: relative;
    padding: 2px 0;

    @media screen and (min-width: 424px) {
      width: 100px;
    }

    &.info {
      background-color: #fca0a0 !important;
      font-size: 13px;
    }

    &.release {
      background-color: #a0d9fc;
      font-size: 13px;
    }

    &.campaign {
      background-color: #98dbb7;
      font-size: 11px;
    }
  }

  &-date {
    font-size: 11px;
    margin: auto;
  }
  &-name {
    font-size: 11px;
    margin: auto;
    flex: 1;
  }
}
</style>
